import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/dresses', label: '分类' },
  { to: '/articles', label: '穿搭灵感' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const bgClass = scrolled || !isHome
    ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
    : 'bg-transparent';
  const textClass = scrolled || !isHome ? 'text-foreground-900' : 'text-background-50';
  const logoClass = scrolled || !isHome ? 'text-foreground-900' : 'text-background-50';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`font-heading text-xl font-semibold ${logoClass} whitespace-nowrap cursor-pointer`}>
            蘑菇网
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                    ? scrolled || !isHome ? 'text-primary-500' : 'text-accent-300'
                    : `${textClass} hover:text-primary-500`
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/dresses"
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/20 text-background-50 hover:bg-background-50/30'
              }`}
            >
              立即选购
            </Link>
          </div>

          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${textClass}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`py-2 text-sm font-medium whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/dresses"
              className="mt-2 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              立即选购
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}